// ─── Booking Status Utilities ─────────────────────────────────────────────────
// Single source of truth สำหรับ delivery booking status ทุกหน้า

const STATUS_CONFIG = {
  pending: { label: 'รอรับสินค้า', bg: '#f97316', text: '#ffffff' },
  noshow: { label: 'ไม่มาจัดส่ง', bg: '#ef4444', text: '#ffffff' },
  delivered: { label: 'จัดส่งสำเร็จ', bg: '#10b981', text: '#ffffff' },
  delivered_late: { label: 'จัดส่งสำเร็จ (คอนเฟิร์มล่าช้า)', bg: '#10b981', text: '#ffffff' },
  cancelled: { label: 'ยกเลิกแล้ว', bg: '#d1d5db', text: '#4b5563' },
  rejected: { label: 'ปฏิเสธโดยคลัง', bg: '#9f1239', text: '#ffffff' }
}

export function statusLabel (status) {
  return STATUS_CONFIG[status]?.label || status
}

export function statusBg (status) {
  return STATUS_CONFIG[status]?.bg || '#d1d5db'
}

export function statusTextColor (status) {
  return STATUS_CONFIG[status]?.text || '#4b5563'
}
